import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import {createApp} from 'vue'
import {createPinia} from 'pinia'
import i18next from 'i18next'
import I18NextVue from 'i18next-vue'
import './assets/shadcn.css'
import App from './App.vue'
import router from './router'
import {translations as miniappTranslations} from './translations'
import {translations as sharedTranslations} from '../../shared/translations'

const translations = {
  en: {translation: {...sharedTranslations.en.translation, ...miniappTranslations.en.translation}},
  ru: {translation: {...sharedTranslations.ru.translation, ...miniappTranslations.ru.translation}},
}

function getSavedLang(): string {
  try {
    const stored = localStorage.getItem('local')
    if (stored) {
      const parsed = JSON.parse(stored)
      if (parsed.lang && typeof parsed.lang === 'string') return parsed.lang
    }
  } catch {}
  return 'en'
}

i18next.init({
  lng: getSavedLang(),
  resources: translations,
})

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(pinia)
app.use(router)
app.use(I18NextVue, {i18next})

app.mount('#app')
